import z from 'zod';

export const approvalNotesSchema = z.object({
  transactionSummary: z.string().optional().default(''),
  lenderNotes: z.string().optional().default(''),
  dealerNotes: z.string().optional().default(''),
  creditSubStage: z.number().nullable().optional(),
});
